import React from "react";

import { Modal } from "../Modal";
import { useToggle } from "../hooks";

interface IProps {
  text?: string;
  textClasses?: string;
  reverse?: boolean;
  children?: React.ReactNode;
  title?: string;
}

export function LearnMoreModal({ text = "Learn more", textClasses = "", reverse = false, children, title }: IProps) {
  const { toggleOn, onToggleClick } = useToggle();

  const txtArr = [
    <p className={textClasses}>{text}</p>,
    <span className="w-4 h-4 text-xs rounded-full bg-gray-500 text-white">?</span>
  ];
  return (
    <>
      <button
        type="button"
        className="text-gray-500 text-sm font-medium flex items-center space-x-1"
        onClick={onToggleClick}
      >
        {reverse ? txtArr.reverse() : txtArr}
      </button>
      <Modal isOpen={toggleOn} title={title} closeModal={onToggleClick}>
        {children}
      </Modal>
    </>
  );
}
